<template>
	<div class="border-top">
		<SOFilterTitle :title="title" :diterapkan="diterapkan" :id="id"/>
		<div class="p-x-16 p-d-16" style="display: none" :id="id">
			<div v-if="keterangan !== ''" class="f-regular f-12 f-c-midgrey m-d-16">
				{{ keterangan }}
			</div>

			<div class="m-d-16">
				<SOInputDate
					:title="'Tanggal Awal'"
					:id="'start-date'"
					:placeholder="'Tanggal Awal'"
					:value="filterItem.periode.startDate === '' ? $moment().format('YYYY-MM-DD') : filterItem.periode.startDate"
					@get-date="selectedStartDate"
				/>
			</div>
			<SOInputDate
				:title="'Tanggal Akhir'"
				:id="'end-date'"
				:placeholder="'Tanggal Akhir'"
				:value="filterItem.periode.endDate === '' ? $moment().format('YYYY-MM-DD') : filterItem.periode.endDate"
				:min-date="filterItem.periode.startDate === '' ? '' : filterItem.periode.startDate"
				@get-date="selectedEndDate"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputDate from "@/so-components/global/input/SOInputDate";

export default {
	name: "SOFilterTanggalTransfer",
	components: {
		SOFilterTitle,
		SOInputDate,
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem",
		}),
	},
	props: {
		id: String,
		title: {
			type: String,
			default: "Tanggal Transfer"
		},
		keterangan: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			checkedPeriodeId: "",
			diterapkan: false,
		}
	},
	mounted() {
		if (this.title === "") this.title = "Tanggal Transfer"
		this.diterapkan = this.filterItem.periode.startDate !== "" && this.filterItem.periode.endDate !== ""
	},
	methods: {
		selectedStartDate(val) {
			let temp = this.filterItem
			temp.periode.startDate = val
			temp.periode.endDate = $("#end-date").val()
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
			this.diterapkan = temp.periode.startDate !== "" && temp.periode.endDate !== ""
		},
		selectedEndDate(val) {
			let temp = this.filterItem
			temp.periode.startDate = $("#start-date").val()
			temp.periode.endDate = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
			this.diterapkan = temp.periode.startDate !== "" && temp.periode.endDate !== ""
		},
	}
}
</script>

<style scoped>

</style>